<template>
    <div>
        <div class="row" data-aos="fade-up">
            <div class="col-4">
                                  <div v-for="(item,x) in col1" :key="`col1-${x}-${item.id || item.featured}`" class="pb-4 p-1">
                      <img :src="$url+'/'+item.featured" class="img-fluid cursor-pointer" 
                      @click="show(item)" :alt="item.title"/>
                  </div>
              </div>
              <div class="col-4">
                  <div v-for="(item,y) in col2" :key="`col2-${y}-${item.id || item.featured}`" class="pb-4 p-1">
                      <img  :src="$url+'/'+item.featured" class="img-fluid cursor-pointer" 
                      @click="show(item)" :alt="item.title"/>
                  </div>
              </div>
              <div class="col-4">
                  <div v-for="(item,z) in col3" :key="`col3-${z}-${item.id || item.featured}`" class="pb-4 p-1">
                      <img :src="$url+'/'+item.featured" class="img-fluid cursor-pointer" 
                      @click="show(item)" :alt="item.title"/>
                  </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MasonryComponent',
    props:['items'],
    data(){
        return{
            masonry:{},
            col1:{},
            col2:{},
            col3:{},
            all:{}
        }
    },
    created(){
        this.masonry = this.$props.items
        this.all  = this.masonry.all
        this.col1 = this.masonry.col1
        this.col2 = this.masonry.col2
        this.col3 = this.masonry.col3
    },
    mounted(){
        // Force a re-render after component is mounted
        this.$forceUpdate()
    },
    methods:{
        show(item) {
            this.$emit('show-image', item)
        }
    },
    watch: {
        items: {
            handler(newItems) {
                if (newItems) {
                    this.masonry = newItems
                    this.all = this.masonry.all
                    this.col1 = this.masonry.col1
                    this.col2 = this.masonry.col2
                    this.col3 = this.masonry.col3
                    this.$nextTick(() => {
                        this.$forceUpdate()
                    })
                }
            },
            immediate: true,
            deep: true
                },
        methods: {
            show(item) {
                this.$emit('show-image', item)
            }
        }
    }
}
</script>